<template>
    <tr class="module__edit_cersions_table_item">
        <td class="module__edit_cersions_table_item_version">
            <div class="columns is-vcentered">
                <div class="column is-narrow">
                    <template v-if="moduleVersionReleaseNotes">
                    <component-button
                        :name="'module-edit-version-table-item-collapse'"
                        :icon="true"
                        :icon-name="collapseActive ? 'chevron-up' : 'chevron-down'"
                        :icon-align="'right'"
                        :text="true"
                        :underline="true"
                        :size="'medium'"
                        @click="performEmit('emit-collapse', index)"
                    >{{ moduleVersion }}</component-button>
                    </template>
                    <template v-else>
                        {{ moduleVersion }}
                    </template>
                </div>
            </div>
        </td>
        <td class="module__edit_cersions_table_item_releasedby">{{ moduleReleasedBy }}</td>
        <td class="module__edit_cersions_table_item_releasedate">{{ moduleReleaseDate }}</td>
    </tr>
</template>

<script>
import { fromUTCDateTimeToLocalISOCustom, toLocaleDateTime, toLocaleTime } from '@/functions'
import ComponentButton from '@/components/default/shared/ComponentButton'

export default {
  name: 'module-edit-versions-table-item',
  components: { ComponentButton },
  props: {
    item: {
      type: Object,
      required: true
    },
    index: {
      type: [Number, String]
    },
    collapseActive: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    moduleVersion () {
      return this.item.version
    },
    moduleReleasedBy () {
      return this.item.releasedBy
    },
    moduleVersionReleaseNotes () {
      return this.item.releaseNotes
    },
    moduleReleaseDate () {
      const releaseDate = this.item.releaseDate
      return releaseDate ? toLocaleDateTime(fromUTCDateTimeToLocalISOCustom(this.item.releaseDate)) + ' ' + toLocaleTime(fromUTCDateTimeToLocalISOCustom(this.item.releaseDate)) : ''
    }
  },
  methods: {
    performEmit (message, value) {
      this.$emit('emit', { message: message, value: value })
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/modules/moduleaddeditversionstableitem";
</style>
